// extracted by mini-css-extract-plugin
export default {"container":"Resources_container__knGtE"};